import { render, staticRenderFns } from "./ForumResponseReactions.vue?vue&type=template&id=20e7243f&scoped=true"
import script from "./ForumResponseReactions.vue?vue&type=script&lang=js"
export * from "./ForumResponseReactions.vue?vue&type=script&lang=js"
import style0 from "./ForumResponseReactions.vue?vue&type=style&index=0&id=20e7243f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20e7243f",
  null
  
)

export default component.exports